<div>
  <img class="header-image" [src]="producePath" alt="produce" />
  <div class="content-wrapper">
    <div class="left-content">
      <div>
        <p class="rate-text-style">
          Transload Explore available rates by Origin or Destination Transload.
        </p>
        <div>
          <lib-static-dropdown
            [dropdownDataList]="months"
            labelName="Month & Year"
            [useDifferentSet]="true"
            [selectedValue]="selectedMonth"
            [required]="true"
            (selectedType)="onDateSelected($event)"
          >
          </lib-static-dropdown>
        </div>
        <br />
        @if(originTransloadChips.length > 0 || destinationTransloadChips.length
        > 0){
        <div class="current-rates">
          <!-- Origin Transload -->
          @if (originTransloadChips.length > 0) {
          <ng-container>
            <h6>Origin Transload</h6>
            <br />
            @for (k of [render.origin]; track k) {
            <app-chip-filter
              class="chip-section"
              [chips]="originTransloadChips"
              [selected]="
                selected?.moveType === 'ORIGIN' ? selected?.id ?? '' : ''
              "
              (selectedChip)="onSelectOrigin($event)"
            ></app-chip-filter>
            }
            <br />
          </ng-container>
          }
          <!-- Destination Transload -->
          @if (destinationTransloadChips.length > 0) {
          <ng-container>
            <h6>Destination Transload</h6>
            <br />
            @for (k of [render.destination]; track k) {
            <app-chip-filter
              class="chip-section"
              [chips]="destinationTransloadChips"
              [selected]="
                selected?.moveType === 'DESTINATION' ? selected?.id ?? '' : ''
              "
              (selectedChip)="onSelectDestination($event)"
            />
            }
            <br />
          </ng-container>
          }
        </div>
        }
      </div>
    </div>
    <!-- Right side content -->
    <div class="right-content">
      <app-custom-rate></app-custom-rate>
      @if(salesManagerDetails){
      <app-representative-details
        [salesManagerDetails]="salesManagerDetails"
      ></app-representative-details>
      }
    </div>
  </div>
  <!-- full content -->
  <div class="full-screen">
    @if(selected?.id){
    <div class="search-table-container">
      <app-public-review
        #publicReviewProd
        [currentId]="selected.id"
        [publicProgramData]="publicProgramData"
      ></app-public-review>
    </div>
    } @else {
    <div>
      <app-no-results></app-no-results>
    </div>
    }
  </div>
</div>
